import { getDefineList } from "@/helpers/utility/Type";
import { defineStore } from "pinia";

const definePositionsList = getDefineList<{ x?: number; y?: number; width?: number; height?: number }>();

const popupSizes = definePositionsList({
  netLayers: { },
});

export type PopupSizeKey = keyof typeof popupSizes;

export const usePopupSizes = defineStore("editor/popupSizes", {
  state: () => ({
    ...popupSizes
  }),
  actions: {
    setSize(id: PopupSizeKey, size: { x: number; y: number; width: number; height: number }) {
      this.$patch((state) => {
        state[id] = { ...size };
      });
    },
    updateSize(id: PopupSizeKey, size: Partial<{ x: number; y: number; width: number; height: number }>) {
      this.$patch((state) => {
        state[id] = { ...state[id], ...size };
      });
    }
  }
});
